namespace advisorop.components.advisor {
    
    export class AccountMaintenanceController{
        $router;
        accounts: Array<domains.IBOUnmappedAccount>;
        lovs: Array<domains.ILOV> = [];
        titleTypes: Array<domains.ILOV> = [];

        static $inject = ["advisorService", "generalService"];
        constructor(private advisorService: services.AdvisorService, private generalService: services.GeneralService) {            
            
        }

      loadUnmappedAccounts(syncWithPp: boolean = false): void {
        if (syncWithPp) {
          toastr.info("This operation will take some time please wait ...");
        }
        var rez = this.advisorService.getUnmappedAccounts(syncWithPp);

            rez.then((data) => {
              this.accounts = data.data;
              if (syncWithPp) {
                toastr.success("Syncronisation with Portfolio Pathway completed");
              }
            }).catch((data) => {
                toastr.error("Error " + data.status + " " + data.data);
            });
        };


        $onInit(): void {
            this.loadUnmappedAccounts();
        }

        $routerOnActivate(next, previous) {          
        }        

    }



    class AccountMaintenance implements ng.IComponentOptions {

        public bindings: any;
        public controller: any;
        public controllerAs: string;
        public templateUrl: string;
        //public $routeConfig: any;
        $canActivate;

        constructor() {
            this.bindings = {
                "$router": "<"
            };
            this.controller = AccountMaintenanceController;
            this.controllerAs = "vm";
            this.templateUrl = 'spa/advisor-module/views/account-maintenance.html';  
            this.$canActivate = ["advisorService", (advisorService: services.AdvisorService) => {
                if (advisorService.isAdminModeEnabled()) {
                    toastr.info("Please exit from Admin Mode to enable account maintenance");
                    return false;
                }
                return true;
            }];          
        }
    }
    angular.module(Constants.APP).component("accountMaintenance", new AccountMaintenance());
    
}